import React from "react";

const SectionTwo = () => {
  return (
    <div className="bg-blue-7 flex justify-center w-full pt-[60px] pb-[80px]">
      <div className="max-w-screen-xl flex justify-between w-full text-white flex-col md:flex-row px-5 xl:px-0">
        <div className="flex flex-col gap-4 md:w-2/5 w-full text-center md:text-left">
          <p className="text-7xl pt-5">Moving Out ?</p>
          <img
            src="/assets/images/services/clean.png"
            alt=""
            className="h-[400px] w-auto object-contain"
          />
        </div>

        <div className="flex flex-col gap-3 md:w-3/5 w-full md:pt-[100px] pt-10">
          <p className="text-xl">
            <span className="md:text-6xl text-4xl">End of Lease Cleaning</span>{" "}
            service is designed to help you leave your property spotless and
            ready for the final inspection. We handle every detail, from deep
            cleaning carpets and scrubbing kitchens to polishing bathrooms and
            more, ensuring you meet all lease requirements.
            <br />
            <br /> Let us take the stress out of moving with a thorough,
            reliable clean that leaves a lasting impression.
            <br />
            <br />
            Book today to make your move smoother and worry-free!
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
